import { z } from "zod";
import { UserRole } from "../../models/User";

export const passwordSchema = z
  .string()
  .min(8, "At least 8 characters")
  .regex(/[A-Z]/, "At least one uppercase letter")
  .regex(/[0-9]/, "At least one number")
  .regex(/[^a-zA-Z0-9]/, "At least one symbol");

export const createUserSchema = z.object({
  username: z.string().min(1, "Username is required"),
  email: z
    .string()
    .min(1, "Email is required")
    .email("Invalid email address"),
  password: passwordSchema,
  role: z.nativeEnum(UserRole),
});

/**
 * Zod schema for the EditUserModal form.
 * Mirrors backend UpdateUserCommandValidator:
 * - Username: NotEmpty
 * - Email: NotEmpty
 * - Role: Must be Editor, Viewer, or Admin
 */
export const editUserSchema = z.object({
  username: z.string().min(1, "Username is required"),
  email: z
    .string()
    .min(1, "Email is required")
    .pipe(z.email("Invalid email address")),
  role: z.nativeEnum(UserRole),
  managedOrganizations: z.array(z.string()),
});
